// modules/signature.js
export const Signature = {
    canvas: null,
    ctx: null,
    drawing: false,

    init: (canvasId) => {
        Signature.canvas = document.getElementById(canvasId);
        if (!Signature.canvas) return;

        Signature.ctx = Signature.canvas.getContext('2d');
        Signature.setupListeners();
        Signature.clear(); // Inicjalizacja czystego tła
    },

    setupListeners: () => {
        const getPos = (e) => {
            const rect = Signature.canvas.getBoundingClientRect();
            // Obsługa dotyku i myszki
            const clientX = e.touches ? e.touches[0].clientX : e.clientX;
            const clientY = e.touches ? e.touches[0].clientY : e.clientY;
            return {
                x: clientX - rect.left,
                y: clientY - rect.top
            };
        };

        const start = (e) => {
            Signature.drawing = true;
            const pos = getPos(e);
            Signature.ctx.beginPath();
            Signature.ctx.moveTo(pos.x, pos.y);
            e.preventDefault();
        };

        const move = (e) => {
            if (!Signature.drawing) return;
            const pos = getPos(e);
            Signature.ctx.lineWidth = 2;
            Signature.ctx.lineCap = "round";
            Signature.ctx.strokeStyle = "#000";
            Signature.ctx.lineTo(pos.x, pos.y);
            Signature.ctx.stroke();
            e.preventDefault();
        };

        const stop = () => {
            Signature.drawing = false;
        };

        // Myszka
        Signature.canvas.addEventListener('mousedown', start);
        Signature.canvas.addEventListener('mousemove', move);
        window.addEventListener('mouseup', stop);

        // Dotyk (dla tabletów/kiosku)
        Signature.canvas.addEventListener('touchstart', start, { passive: false });
        Signature.canvas.addEventListener('touchmove', move, { passive: false });
        Signature.canvas.addEventListener('touchend', stop);
    },

    clear: () => {
        if (!Signature.ctx) return;
        Signature.ctx.clearRect(0, 0, Signature.canvas.width, Signature.canvas.height);
        // Opcjonalnie: białe tło zamiast przezroczystości
        Signature.ctx.fillStyle = "white";
        Signature.ctx.fillRect(0, 0, Signature.canvas.width, Signature.canvas.height);
    },

    getDataUrl: () => {
        return Signature.canvas ? Signature.canvas.toDataURL("image/png") : null;
    }
};